import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type Policy = Record<string, unknown>;

export interface PolicyState {
  policies: Policy[];
}

const initialState: PolicyState = {
  policies: [],
};

const policiesSlice = createSlice({
  name: 'policies',
  initialState,
  reducers: {
    loadNewPolicy(state, action: PayloadAction<{ policy: any }>) {
      state.policies.push(action.payload.policy);
    },
    loadAllNewPolicies(state, action: PayloadAction<{ policies: any[] }>) {
      state.policies = action.payload.policies;
    },
    updatePolicyInsureds(state, action: PayloadAction<{ policies: any[] }>) {
      state.policies = action.payload.policies;
    },
  },
});

export const { loadNewPolicy, loadAllNewPolicies, updatePolicyInsureds } = policiesSlice.actions;
export default policiesSlice.reducer;
